import React from 'react';
import { AdminLayout } from '../components/AdminLayout';
import UserTableComponent from '../components/AdminForms/User/UserTableComponent';

const ManageUsers: React.FC = () => {
    return (
        <AdminLayout title="Users">
            <UserTableComponent />
        </AdminLayout>
    );
};

export default ManageUsers;
